module.exports = __webpack_public_path__ + "static/img/zhhq-qjdl-01.afe5183.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zhhq-qjdl-01.png
// module id = Rvi7
// module chunks = 1